import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Displays selected-variant specification data and updates on variant change.
 *
 * @extends {Component}
 */
class ProductVariantMetafield extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateMetafield);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateMetafield);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateMetafield = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newMetafield = event.detail.data.html.querySelector(
      `product-variant-metafield[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newMetafield) return;

    this.className = newMetafield.className;
    this.style.cssText = newMetafield.style.cssText;
    morph(this, newMetafield, { childrenOnly: true });
  };
}

if (!customElements.get('product-variant-metafield')) {
  customElements.define('product-variant-metafield', ProductVariantMetafield);
}
